import { render } from "./EventList.vue?vue&type=template&id=be0cf08e&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=be0cf08e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be0cf08e"

export default script